module.exports = __webpack_public_path__ + "img/8989.2f464e39.jpg";